import { createGlobalStyle } from 'styled-components'
// eslint-disable-next-line import/no-unresolved
import { PancakeTheme } from 'toonswap-uikit/dist/theme'

declare module 'styled-components' {
  /* eslint-disable @typescript-eslint/no-empty-interface */
  export interface DefaultTheme extends PancakeTheme {}
}

const GlobalStyle = createGlobalStyle`
  :root {
    --app-button-bg: #fe7b2a;
    --app-button-border: #2b3335;
    --app-button-text: #ffffff;
    --app-button-disabled-bg: #747f81;
  }

  * {
    font-family: 'Kanit', sans-serif;
  }
  body {
    background-size: 100%;
    background-color: #96DBFA;

    button {
      background-color: var(--app-button-bg);
      border: 2px solid var(--app-button-border);
      border-radius: 12px;
      color: var(--app-button-text);
    }

    button:hover:not(:disabled):not(.pancake-button--disabled):not(:active) {
      opacity: 0.7;
    }

    button:disabled,
    button.pancake-button--disabled {
      background-color: var(--app-button-disabled-bg);
      border-color: var(--app-button-disabled-bg);
      color: var(--app-button-text);
    }

    .nft-loader {
      color: ${({ theme }) => theme.colors.text};
    }

    .MuiButton-root.Mui-disabled {
      color: ${({ theme }) => theme.colors.text};
    }

    .MuiPaper-root {
      background-color: ${({ theme }) => theme.colors.card};
      box-shadow: none;
      .MuiTableContainer-root {
        p {
          color: ${({ theme }) => theme.colors.text};
        }
        thead {
          th {
            background-color: ${({ theme }) => theme.colors.card};
            color: ${({ theme }) => theme.colors.text};
          }
        }
        tbody {
          td {
            color: ${({ theme }) => theme.colors.text};
          }
        }
      }

      .MuiTablePagination-root {
        color: ${({ theme }) => theme.colors.text};
        button {
          ${({ theme }) => theme.colors.text};
        }
        svg {
          fill: ${({ theme }) => theme.colors.text};
        }
      }

      li {
        color: ${({ theme }) => theme.colors.text};
      }
    }

    .MuiButtonGroup-root {
      background-color: ${({ theme }) => theme.colors.background};
      color: ${({ theme }) => theme.colors.text};
    }

    img {
      height: auto;
      max-width: 100%;
    }
  }

  .ReactCollapse--collapse {
    transition: height 500ms;
  }
`

export default GlobalStyle
